const
  NAME               = 'datepicker',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],
  // NOTE: Maybe more than one datapicker should be included and the ID should be unique
  DAYS_CONTAINER     = '.datepicker-days > tbody',
  MONTH_NAMES        = {
    ES: [
      "enero", "febrero", "marzo",      "abril",   "mayo",      "junio",
      "julio", "agosto",  "septiembre", "octubre", "noviembre", "diciembre"
    ],
    EU: [// Euskera
      "urtarrila", "otsaila", "march",     "april", "mayo",   "june",
      "uztailean", "abuztua", "september", "urria", "azaroa", "abenduan"
    ]
  }
;

/**
 * To get the total days of the current month
 */
Date.prototype.monthDays = function() {
  let date = new Date(this.getFullYear(), this.getMonth() + 1, 0);
  return date.getDate();
};

class Datepicker {
  constructor(element$) {
    this._element$ = element$;
    this.dates     = [];
    this.language  = 'ES';
    this.year;
    this.month;

    this.resetDateFields();
    this.changeLanguage();
    let current = new Date();
    this.generateDays(current.getFullYear(), current.getMonth() + 1);
    $('.toggle-year',                 this._element$).on('click', (e) => this.onClick(e));
    $('.toggle-month',                this._element$).on('click', (e) => this.onClick(e));
    $('.schedule-search-way ~ label', this._element$).on('click', (e) => this.byMultipleDate(e));
    $('.daily-search-way ~ label',    this._element$).on('click', (e) => this.byMultipleDate(e));
    $('.daily-search-way',            this._element$).prop('checked', true);

    // NOTE: Change language with $(ELEMENT).data('voc-datepicker', 'ES').trigger('changeLanguage');
    // NOTE: Possible languages: 'ES' | 'EU'
    this._element$.on('changeLanguage', this.changeLanguage.bind(this));
  }

  /**
   * Enabled/disabled the end period fields. It depends of the clicked option[daily or schedule]
   */
  byMultipleDate(event) {
    $('.date-row input', this._element$).val('');
    if ($(event.target).prev().hasClass('schedule-search-way')) {
      $('.date-row.date-periodo',       this._element$).removeClass('_inactive');
      $('.date-row.date-periodo input', this._element$).prop('disabled', false);
      $('.daily-search-way',            this._element$).prop('checked', false);
    } else if ($(event.target).prev().hasClass('daily-search-way')) {
      $('.date-row.date-periodo',       this._element$).addClass('_inactive');
      $('.date-row.date-periodo input', this._element$).prop('disabled', true);
      $('.schedule-search-way',         this._element$).prop('checked', false);
    }
    $('.active', this._element$).removeClass('active');
    this.dates = [];
  }

  /**
   *
   */
  toggleActive(event) {
    // NOTE: Fill the start and end date on click a day cell, when schedule optinon is selected
    if ($('.schedule-search-way:checked', this._element$).length > 0) {
      $('.active', this._element$).removeClass('active');

      // NOTE: Clear previous selection
      if (this.dates.length > 1) {
        $('.date-row input', this._element$).val('');
        $('.active', this._element$).removeClass('active');
        this.dates = [];
      }

      // NOTE: First click(start day) of new selection
      if (this.dates.length === 0) {
        $(event.target).addClass('active');
        this.dates.push($(event.target).attr('data-date'));
        $('input[data-voc-start-dd]',   this._element$).val(this.pad($(event.target).attr('data-day')));
        $('input[data-voc-start-mm]',   this._element$).val(this.pad($(event.target).attr('data-month')));
        $('input[data-voc-start-aaaa]', this._element$).val($(event.target).attr('data-year'));
      } else {// NOTE: Second click(end day) of new selection
        let dateStart = new Date(this.dates[0]);
        let dateEnd   = new Date($(event.target).attr('data-date'));
        this.dates    = [];

        if (dateStart.getTime() > dateEnd.getTime()) {
          let temp  = dateStart;
          dateStart = dateEnd;
          dateEnd   = temp;
        }

        $('input[data-voc-start-dd]',   this._element$).val(this.pad(dateStart.getDate()));
        $('input[data-voc-start-mm]',   this._element$).val(this.pad(dateStart.getMonth() + 1));
        $('input[data-voc-start-aaaa]', this._element$).val(dateStart.getFullYear());

        $('input[data-voc-end-dd]',     this._element$).val(this.pad(dateEnd.getDate()));
        $('input[data-voc-end-mm]',     this._element$).val(this.pad(dateEnd.getMonth() + 1));
        $('input[data-voc-end-aaaa]',   this._element$).val(dateEnd.getFullYear());

        while (dateStart.getTime() <= dateEnd.getTime()) {
          let dateStr = `${dateStart.getFullYear()}-${this.pad(dateStart.getMonth() + 1)}-${this.pad(dateStart.getDate())}`;
          this.dates.push(dateStr);
          $(`[data-date="${dateStr}"]`, this._element$).addClass('active');
          dateStart = new Date(dateStart.setDate(dateStart.getDate() + 1));
        }
      }
    } else {// NOTE: Fill the start date on click a day cell, when daily option is selected
      $('.active', this._element$).not(event.target).removeClass('active');
      $(event.target).addClass('active');
      $('input[data-voc-start-dd]',   this._element$).val(this.pad($(event.target).attr('data-day')));
      $('input[data-voc-start-mm]',   this._element$).val(this.pad($(event.target).attr('data-month')));
      $('input[data-voc-start-aaaa]', this._element$).val($(event.target).attr('data-year'));
    }
  }

  /**
   * Garantee that every numbers has two places
   */
  pad(num) {
      return num < 10 && num.toString().length === 1 ? `0${num}` : num ;
  }

  /**
   * Actions when click on next and back arrow of year and month slide
   */
  onClick(event) {
    if ($(event.target).hasClass('toggle-year')) {
      let incYear = $(event.target).hasClass('leftArrow') ? -1 : 1;
      this.generateDays(this.year + incYear, this.month);
    } else {//toggle-month
      let incMonth = $(event.target).hasClass('leftArrow') ? -1 : 1;
      this.generateDays(this.year, this.month + incMonth);
    }
  }

  /**
   * Paint the calendar based on the year and month given
   */
  generateDays(year, month) {
    this.year  = year;
    this.month = month;

    if (this.month > MONTH_NAMES[this.language].length) {
      this.year++;
      this.month = this.month % MONTH_NAMES[this.language].length;
    } else if (this.month <= 0) {
      this.year--;
      this.month = MONTH_NAMES[this.language].length;
    }

    $(DAYS_CONTAINER, this._element$).children().remove();
    let dateGenerated  = new Date(this.year, this.month - 1, '01');

    this.changeLanguage();
    $('.datepicker-year .name',  this._element$).text(this.year);

    let returntemplate = this.buildTemplate(dateGenerated);
    $(DAYS_CONTAINER, this._element$).append(returntemplate);
    $('.day.voc-enabled', this._element$).on('click', (e) => this.toggleActive(e));
  }

  /**
   * Build the days matrix
   */
  buildTemplate(date) {
    // NOTE: The Sunday is 0, but it is necessary to start on Monday
    let today, todayDay, todayMonth, todayYear, currentDay, startDay, template;

    today      = new Date();
    todayDay   = today.getDate();
    todayMonth = today.getMonth() + 1;
    todayYear  = today.getFullYear();
    currentDay = date.getDay() > 0 ? date.getDay() : 7;
    startDay   = currentDay;
    template   = `<tr>`;

    // NOTE: Creating the empty cells of the first row
    for (let i = 1; i < currentDay; i++) {
      template += `<td></td>`;
    }

    // NOTE: Fill the days cells
    for (let i = 1; i <= date.monthDays(); i++, startDay++) {
      // NOTE: Reset the week day[between 1 and 7]
      let disabledClass, dateTotal, activeClass;

      if (startDay > 7) {
        template += `</tr><tr>`;
        startDay = 1;
      }

      disabledClass = (i > todayDay && this.month === todayMonth && this.year === todayYear) ||
                          (this.month > todayMonth && this.year >= todayYear) ||
                          (this.year > todayYear) ?
                          'voc-disabled' :
                          'voc-enabled';

      dateTotal = `${this.year}-${this.pad(this.month)}-${this.pad(i)}`;
      activeClass = this.dates.indexOf(dateTotal) !== -1 ? 'active' : '';
      template += `<td class="day ${activeClass} ${disabledClass}"
                      data-day="${this.pad(i)}"
                      data-month="${this.pad(this.month)}"
                      data-year="${this.year}"
                      data-date="${dateTotal}">${this.pad(i)}</td>`;
    }

    // NOTE: Creating the empty cells of the last row
    for (let i = startDay; i < 8; i++) {
      template += `<td></td>`;
    }

    return template + `</tr>`;
  }

  changeLanguage() {
    this.language = this._element$.data('voc-datepicker-language') !== undefined ?
      this._element$.data('voc-datepicker-language') :
      'ES';
    $('.datepicker-month .name', this._element$).text(MONTH_NAMES[this.language][this.month - 1]);
  }

  resetDateFields() {
    $('input[data-voc-start-dd]',   this._element$).val('');
    $('input[data-voc-start-mm]',   this._element$).val('');
    $('input[data-voc-start-aaaa]', this._element$).val('');
    $('input[data-voc-end-dd]',     this._element$).val('');
    $('input[data-voc-end-mm]',     this._element$).val('');
    $('input[data-voc-end-aaaa]',   this._element$).val('');
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new Datepicker($(this));
    });
  }
}

$.fn[NAME]             = Datepicker._jQueryInterface;
$.fn[NAME].Constructor = Datepicker;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return Datepicker._jQueryInterface;
};

export default Datepicker;



// WEBPACK FOOTER //
// ./src/plugins/datepicker.js